import { render } from "./ApiProductsView.vue?vue&type=template&id=15bd89ed&scoped=true"
import script from "./ApiProductsView.vue?vue&type=script&lang=js"
export * from "./ApiProductsView.vue?vue&type=script&lang=js"

import "./ApiProductsView.vue?vue&type=style&index=0&id=15bd89ed&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bd89ed"]])

export default __exports__